<template>
  <div>
    <vx-card>        
      <h3 class="gw-det-title">Apoyo fotográfico</h3>
      <p class="gw-det-sub">Fotos tomadas durante la visita.</p>       
      <swiper :options="swiperOption">
        <swiper-slide v-for="(project_photo, index_project_photo) in project.project_photos" :key="index_project_photo">
          <img
            class="responsive"
            :src="photoSrc(project_photo)"
            :alt="project_photo.title"
            @error="refreshPhoto(project_photo)"
          >
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>      
    </vx-card>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import api from '@/mixins/api.js'
import secureFiles from '@/mixins/secureFiles.js'
import { normalizeSecureFileUrl } from '@/utils/secureFileUrl'

export default {
  mixins: [api, secureFiles],
  props: {
    project: Object
  },
  data() {
    return {
      photoUrls: {},
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      }
    }
  },
  watch: {
    'project.project_photos': {
      handler () {
        this.loadPhotoUrls()
      },
      deep: true
    }
  },
  methods: {
    async loadPhotoUrls () {
      if (!this.project.project_photos) return

      for (const photo of this.project.project_photos) {
        await this.refreshPhoto(photo)
      }
    },
    async refreshPhoto (photo) {
      const cacheKey = photo.id || photo.title

      if (photo.id) {
        const url = await this.resolveSecureFileUrl(photo.url, {
          resourceType: 'project_photo',
          id: photo.id
        })
        if (url) {
          this.$set(this.photoUrls, cacheKey, url)
        }
        return
      }

      const legacyUrl = normalizeSecureFileUrl(photo.url)
      if (legacyUrl) {
        this.$set(this.photoUrls, cacheKey, legacyUrl)
      }
    },
    photoSrc (projectPhoto) {
      const cacheKey = projectPhoto.id || projectPhoto.title
      return this.photoUrls[cacheKey] || ''
    }
  },
  mounted () {
    this.loadPhotoUrls()
  },
  components:{
    swiper,
    swiperSlide
  }
}
</script>

<style>

</style>
